<template>
  <div class="inner-dashboard">
    <loading
      v-model:active="campaignLoading"
      :is-full-page="true"
      loader="dots"
      :opacity="1"
    />
    <PropertyDashboardSidebarNav
      v-if="!campaignLoading"
      :propertyId="propertyId"
      :campaignId="campaignId"
      :showLeadIntro="showLeadIntro"
      :showTopIntro="showTopIntro"
    />
    <div class="container h-100 pt-4 mt-3" v-if="!campaignLoading">
      <p class="content-header">What is Top Tenant Contacts?</p>
      <div class="row row-cols-1 row-cols-lg-2">
        <div class="col">
          <p class="content-text">
            We’re excited to introduce Top Tenant Contacts—a new feature that
            provides a list of key decision makers at the companies interacting
            with your ad.
          </p>
          <p class="content-sub-title mb-3">
            What contact-level data do we get?
          </p>
          <p class="content-text mb-0">✨ Contact Name</p>
          <p class="content-text mb-0">✨ Job Title</p>
          <p class="content-text mb-0">✨ Company Name</p>
          <p class="content-text mb-0">✨ Email</p>
          <p class="content-text mb-3">✨ LinkedIn Profile</p>
          <p class="content-sub-title mb-3">How does this work?</p>
          <p class="content-text">
            Companies from your target list that view your ad most frequently
            will be listed along with contact information for key
            decision-makers, making it easy for you to connect with them.
          </p>
          <p class="content-sub-title mb-3">
            How do I access Top Tenant Contacts?
          </p>
          <p class="content-text">
            This report requires a minimum spend of <b>$1,000 per month.</b> 
          </p>
          <p class="content-text">
            For more information, please reach out to your account
            representative or info@walkthruit.com
          </p>
        </div>
        <div class="col">
          <div
            style="
              padding: 56.25% 0 0 0;
              position: relative;
              border-radius: 10px;
              overflow: hidden;
            "
          >
            <iframe
              src="https://player.vimeo.com/video/1067449807?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              frameborder="0"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
              style="
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
              "
              title="NEW FEATURE: Leads Identified"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@use "@/assets/vars.sass" as *
.content-header
  font-weight: 600
  font-size: 22px
  line-height: 27.72px
  color: $Main
  margin-bottom: 14px
.content-text
  font-weight: 400
  font-size: 14px
  line-height: 17.64px
  color: $Main
.content-sub-title
  font-weight: 600
  font-size: 14px
  line-height: 17.64px
  color: $Main
</style>

<script>
import { ref } from "vue";
import api from "@/services/BackendConnection";
import PropertyDashboardSidebarNav from "@/components/PropertyDashboardSidebarNav.vue";

export default {
  name: "TopTenantIntroView",
  setup(props) {
    return {
      campaignName: ref(null),
      campaignLoading: ref(true),
      showLeadIntro: ref(null),
      showTopIntro: ref(null),
    };
  },
  props: {
    propertyId: {
      type: String,
      required: true,
    },
    campaignId: {
      type: String,
      required: true,
    },
  },
  components: {
    PropertyDashboardSidebarNav,
  },
  computed: {},
  methods: {
    getCampaignInfo() {
      this.campaignLoading = true;
      var info = {
        campaignId: this.campaignId,
      };
      var _this = this;
      api()
        .getCampaignName(info)
        .then((res) => {
          if (res.data) {
            _this.campaignName = res.data.campaignName;
            var monthlyBudget = res.data.monthlyBudget;
            var showLeadContacts = res.data.showLeadContacts;
            var showTopContacts = res.data.showTopContacts;
            _this.showLeadIntro =
              !showLeadContacts && monthlyBudget && monthlyBudget < 1000;
            _this.showTopIntro =
              !showTopContacts && monthlyBudget && monthlyBudget < 1000;
          }
          _this.campaignLoading = false;
        });
    },
  },
  mounted() {
    this.getCampaignInfo();
    // Load Vimeo Player API script dynamically
    const script = document.createElement("script");
    script.src = "https://player.vimeo.com/api/player.js";
    script.async = true;
    document.body.appendChild(script);
  },
};
</script>